import { HYDRATE } from 'next-redux-wrapper';

import { IFaqArticleDto } from '@r1-frontend/api-domru/content-static/v2/articles/dto/ResponseDto';

import { THydrateAction } from '~/src/store';

export const FETCH_FAQ_CATEGORIES = 'FETCH_FAQ_CATEGORIES';
export const SET_FAQ_CATEGORIES = 'SET_FAQ_CATEGORIES';
export const ERROR_FAQ_CATEGORIES = 'ERROR_FAQ_CATEGORIES';
export const FETCH_FAQ_ARTICLES = 'FETCH_FAQ_ARTICLES';
export const SET_FAQ_ARTICLES = 'SET_FAQ_ARTICLES';
export const ERROR_FAQ_ARTICLES = 'ERROR_FAQ_ARTICLES';
export const SET_QA_ARTICLES = 'SET_QA_ARTICLES';
export const TOGGLE_QA_ARTICLE = 'TOGGLE_FAQ_ARTICLE';


export interface ICategory {
    category_id: number,
    category_name: string,
    slug: string,
}

export interface IArticleName {
    faq_id: number,
    question: string,
    categories: Array<ICategory>,
    slug: string,
}

interface SetQaArticlesAction {
    type: typeof SET_QA_ARTICLES,
    payload: {
        placeAlias: string,
        faqArticles: IFaqArticleDto[],
    },
}

export interface IArticlesByCategory {
    [categoryId:number]: IArticleName[],
}

export interface IFaqArticleWithState {
    key: string,
    id: string,
    question: string,
    answer: string,
    isOpen: boolean,
}

interface IFaqState {
    categories: ICategory[],
    categoriesPlaces: Array<number>,
    categoriesFetching: boolean,
    categoriesError: string | undefined | null,

    articles: IArticlesByCategory,
    articlesPlaces: Array<number>,
    articlesFetching: boolean,
    articlesError: string | undefined | null,

    qaArticles: {
        [placeAlias: string]: IFaqArticleWithState[],
    },
}


const initialState:IFaqState = {
    categories: [],
    categoriesPlaces: [],
    categoriesFetching: false,
    categoriesError: null,

    articles: {},
    articlesPlaces: [],
    articlesFetching: false,
    articlesError: null,
    qaArticles: {},
};

export type TActions = {
    type:
        typeof FETCH_FAQ_CATEGORIES |
        typeof SET_FAQ_CATEGORIES |
        typeof ERROR_FAQ_CATEGORIES |
        typeof FETCH_FAQ_ARTICLES |
        typeof SET_FAQ_ARTICLES |
        typeof TOGGLE_QA_ARTICLE |
        typeof ERROR_FAQ_ARTICLES,
    payload: Partial<IFaqState>,
} | SetQaArticlesAction;

type State = {
    [key: string]: any,
};

export default (state = initialState, action: TActions | THydrateAction): State => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.faq };
        case FETCH_FAQ_CATEGORIES:
        case SET_FAQ_CATEGORIES:
        case ERROR_FAQ_CATEGORIES:
        case FETCH_FAQ_ARTICLES:
        case SET_FAQ_ARTICLES:
        case ERROR_FAQ_ARTICLES: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_QA_ARTICLES: {
            const { placeAlias, faqArticles } = action.payload;
            return {
                ...state,
                qaArticles: {
                    ...state.qaArticles,
                    [placeAlias]: faqArticles.map((article) => ({
                        key: article._id.toString(),
                        id: article._id,
                        question: article.articleQuestion,
                        answer: article.articleAnswer,
                        isOpen: false,
                    })),
                },
            };
        }
        case TOGGLE_QA_ARTICLE: {
            // TODO: требуется рефакторинг стора faq (типизация, action types enum, etc)
            // @ts-ignore Свойства не существуют в типе "Partial".
            const { placeAlias, articleId } = action.payload;
            if (!placeAlias || !articleId) {
                return state;
            }

            return {
                ...state,
                qaArticles: {
                    ...state.qaArticles,
                    [placeAlias]: state.qaArticles[placeAlias].map((article) =>
                        article.id === articleId
                            ? { ...article, isOpen: !article.isOpen }
                            : article),
                },
            };
        }
        default: return state;
    }
};
